module.exports = __webpack_public_path__ + "media/images/countrysquared/eh-034791a50f560dde20a751b9a7fe1c1e.svg";